if($('#career-search').length) {

    let searchContainer = $('#career-search'),
        featuredServices = $('.career-container'),
        searchForm = $('#careers-career-form'),
        searchInput = $('#careers-search-input'),
        resultsContainer = $('#career-search-results'),
        paginationContainer = $('#career-pagination-container'),
        paginationDisplay = $('.career-pagination-display'),
        previousSearch = '',
        initialSearchComplete = false,
        categoryFilterItems = $('.career-filter-category'),
        currentFilterTags = $('.career-current-filter-tags'),
        page = 1;

    searchInput.on('keyup update', function() {
        if(previousSearch.length > 0 && searchInput.val().length === 0) {
            careerSearch();
        }

        previousSearch = searchInput.val();
    });

    searchInput.on('keyup update', debounce(function () {

        if(searchInput.val().length > 2) {
            careerSearch();
        }

    }, 500));

    function debounce (fn, delay) {
        var timeoutID = null
        return function () {
            clearTimeout(timeoutID)
            var args = arguments
            var that = this
            timeoutID = setTimeout(function () {
                fn.apply(that, args)
            }, delay)
        }
    }

    searchForm.on('submit', function(e) {
        e.preventDefault();
        careerSearch();
    });

    $(document).on('click', '.episodes-page-link', function (e) {
        e.preventDefault();
        page = $(this).data('page');
        careerSearch();
    });

    $(document).on('click', '.episodes-page-prev', function (e) {
        e.preventDefault();
        if($(this).hasClass('disabled')) return;
        page--;
        careerSearch();
    });

    $(document).on('click', '.episodes-page-next', function (e) {
        e.preventDefault();
        if($(this).hasClass('disabled')) return;
        page++;
        careerSearch();
    });

    categoryFilterItems.on('click', function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('is-checked');
        if ($('.is-checked').length > 0) {
            $('.js-services-clear').removeClass('d-none');
        } else {
            $('.js-services-clear').addClass('d-none');
        }
        page = 1;
        careerSearch();
    });



    $(document).on('click', '.career-current-filter-tags button', function () {
        $('.career-filter-category-' + $(this).data('category')).parent().removeClass('is-checked');
        if ($('.is-checked').length > 0) {
            $('.js-services-clear').removeClass('d-none');
        } else {
            $('.js-services-clear').addClass('d-none');
        }
        careerSearch();
    });



    $(document).on('click', '.view-all-categories', function (e) {
        e.preventDefault();

        $('.category-hidden').toggleClass('d-none');

        if ($('.category-hidden').hasClass('d-none')) {
            $(this).text('View All');
        } else {
            $(this).text('View Less');
        }
    });


    $(document).on('click', '.js-services-clear', function () {
        categoryFilterItems.parent().removeClass('is-checked');

        $('.js-services-clear').addClass('d-none');

        page = 1;

        careerSearch();
    });



    function careerSearch() {

        let categoryFilters = [];

        categoryFilterItems.each(function() {
            if($(this).parent().hasClass('is-checked')) {
                categoryFilters.push($(this).data('category'));
            }
        });

        // console.log(categoryFilters);

        $.post("/wp-admin/admin-ajax.php", {
            'action': 'career_search',
            'query': searchInput.val(),
            'categories': categoryFilters,
            'page': page,
        }, function (response) {

            resultsContainer.html(response.data.results);
            paginationContainer.html(response.data.pagination);
            paginationDisplay.html(response.data.pagination_display);
            currentFilterTags.html(response.data.current_filter_tags);

            $('html, body').animate({
                scrollTop: $('#career-search').offset().top - 100
            }, 500);

        });

    }

}
